import { useEffect, useState } from "react";
import Status from "../enums/Status";
import IPerson from "../models/people/IPerson";
import peopleService from "../services/peopleService";
import { useTranslation } from "react-i18next";
import { Alert, Col, Container, Row, Spinner } from "react-bootstrap";
import IFilter from "./filter/IFilter";
import { PeopleTable } from "./table/PeopleTable";
import { Filters } from "./filter/Filters";
import { FilterPeople } from "./filter/FilterPeople";
import { PersonModal } from "./personModal/PersonModal";

export default function PeopleDirectory() {
    const { t } = useTranslation();

    const [people, setPeople] = useState<IPerson[]>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [filter, setFilter] = useState<IFilter>({});
    const [status, setStatus] = useState<Status>(Status.LOADING);

    const [showModal, setShowModal] = useState<boolean>(false);
    const [modalPersonId, setModalPersonId] = useState<string>(null!);

    useEffect(() => {
        getPeople(setPeople, setStatus);
    }, []);

    const handleFilterChange = (key: string, value: string) => {
        console.log(key, value);
        
        setFilter({ ...filter, [key]: value });
    }

    const handleModalOpen = (personId: string) => {
        setModalPersonId(personId);
        setShowModal(true);
    };

    const filteredPeople = FilterPeople(people, filter);

    const pageCount = Math.ceil(filteredPeople.length / 10);

    return (
        <>
            <Container>
                <Row className="mb-3">
                    <Col>
                        <h1>{t("people.title")}</h1>
                        <p className="lead">{t("people.description")}</p>
                    </Col>
                </Row>
                {
                    status === Status.LOAD_SUCCESS &&
                    <Filters people={people} filter={filter} onFilterChanged={handleFilterChange} />
                }
                <Row>
                    <Col>
                        {
                            (
                                status === Status.LOADING &&
                                <div className="text-center">
                                    <Spinner />
                                    <span className="d-block sfw-bold">{t("people.loading.multiple")}</span>
                                </div>
                            ) ||
                            (
                                status === Status.LOAD_ERROR &&
                                <Alert variant="danger">{t("people.errors.loadPeople")}</Alert>
                            )
                        }
                        {
                            status === Status.LOAD_SUCCESS &&
                            <PeopleTable
                                people={filteredPeople}
                                page={currentPage}
                                pages={pageCount}
                                onPageClicked={(n) => setCurrentPage(n)}
                                openModal={handleModalOpen}
                                />
                        }
                    </Col>
                </Row>
            </Container>
            <PersonModal
                show={showModal}
                personId={modalPersonId}
                onDismiss={() => setShowModal(false)}
                />
        </>
    );
}

async function getPeople(
    setPeople: (people: IPerson[]) => void,
    setStatus: (status: Status) => void
) {
    setStatus(Status.LOADING);

    try {
        const people = await peopleService.getPeople();
        setPeople(people);
        setStatus(Status.LOAD_SUCCESS);
    } catch {
        setStatus(Status.LOAD_ERROR);
    }
}